import {
    ALL_SMS_LOGS
} from "../constant/ActionType";

export default function AllSmsLog(state = {
    ViewSmsLogs: [],
    lastPage: 1,
}, action) {
    switch (action.type) {
        case ALL_SMS_LOGS:
            return {
                ...state,
                ViewSmsLogs: action?.data?.data?.data,
                lastPage: action?.data?.data?.last_page
            };

        default:
    }

    return state;
}